// extracted by mini-css-extract-plugin
export default {"container":"q6bPMV6dadwkH4ohqLPX"};